import { EventCallback, IEvent, IEventBus, IEventPublisher } from '@cp/shared/cqrs';

const EVENT_NAME = 'event-bus';

export class EventBus extends EventTarget implements IEventBus, IEventPublisher {
  publish<T extends IEvent>(event: T): void {
    this.dispatchEvent(new CustomEvent<T>(EVENT_NAME, { detail: event }));
    this.dispatchEvent(new CustomEvent<T>(event.name, { detail: event }));
  }

  subscribe<T extends IEvent = IEvent>(eventOrCb: EventCallback<T> | T, cb?: EventCallback<T>) {
    const callback = typeof eventOrCb === 'function' ? eventOrCb : cb;
    const eventName = typeof eventOrCb === 'function' ? EVENT_NAME : eventOrCb.name;
    if (!callback) {
      // eslint-disable-next-line no-empty-function
      return () => {};
    }
    const listener = ((event: CustomEvent) => callback(event.detail)) as unknown as EventListenerObject;
    this.addEventListener(eventName, listener);
    return () => this.removeEventListener(eventName, listener);
  }
}
